import { Component } from '@angular/core';

@Component({
  selector: 'menu-desktop',
  templateUrl: './menu-category-desktop.component.html',
  styleUrl: './menu-category-desktop.component.scss',
  standalone: false,
})
export class MenuCategoryDesktopComponent {}
